<template>
    <transition name="fade">
        <div class="flash-message alert" :class="{ 'alert-danger': hasError, 'alert-success': !hasError }" v-if='show'>
            <div class="flash-header">
                <slot name="header"></slot>
            </div>
            <div class="flash-body">
                <div v-if="content">{{ content }}</div>
                <div v-else>
                    <slot name="body">
                        {{ body }}
                    </slot>
                </div>
            </div>
            <div class="flash-buttons">
                <slot name="buttons">
                    <span class="absolute top-0 bottom-0 right-0 p-3 -mt-px cursor-pointer" @click="dismiss">
                        <i class="fa fa-times text-xl"></i>
                    </span>
                </slot>
            </div>
        </div>
    </transition>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    secondsToDisplay: {
        type: [Number, String],
        default: 3
    }
});

const emit = defineEmits(['close']); // Declare custom event "close"

const show = ref(false);
const content = ref('');
const hasError = ref(false);
const seconds = ref(props.secondsToDisplay);

watch(show, (newVal) => {
    if (newVal) {
        setTimeout(() => {
            show.value = false;
        }, seconds.value * 1000);
    }
});

const dismiss = () => {
    show.value = false;
    emit('close');
};

const display = (message) => {
    content.value = message;
    show.value = true;
    hasError.value = false;
};

const error = (message) => {
    content.value = message;
    show.value = true;
    hasError.value = true;
};

defineExpose({
    error,
    display,
});
</script>


<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.flash-message {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    z-index: 9999;
    font-size: 16px;
    @apply shadow-md leading-tight;

    .flash-header {
        @apply text-base font-bold;
    }

    .flash-body {
        @apply mx-3 my-2 pr-5;
    }

    .flash-buttons {
        svg {
            @apply text-black;
        }
    }
}

@screen xs {
    .flash-message {
        width: 100%;
        max-width: 100%;
    }
}

@screen sm {
    .flash-message {
        max-width: 100%;
    }
}

@screen md {
    .flash-message {
        max-width: 100%;
    }
}</style>
